//
// swiper.js
// Theme module
//

'use strict';

//
// Functions
//

(function (waTheme) {

    var ThemeSwiper = (function () {

        ThemeSwiper = function (options) {
            var that = this;

            // DOM
            that.wrapper = (options !== undefined && options["wrapper"]) ? options["wrapper"] : document.querySelectorAll(".js-swiper");
            that.customOptions = (options !== undefined && options["wrapper"]) ? options["custom_options"] : {};

            // VARS
            that.defaultOptions = {
                // preventClicks :true,
                // breakpointsInverse: true,
                // observer: true
            };

            that.defaultOptions = $.extend({}, that.defaultOptions, that.customOptions);

            // DYNAMIC VARS

            // INIT
            that.init();
        };

        ThemeSwiper.prototype.init = function () {
            var that = this;

            that.wrapper.forEach(element => {

                console.log("init");

                let data = element.getAttribute("data-swiper");
                let dataOptions = data ? JSON.parse(data) : {};

                dataOptions = $.extend({}, that.defaultOptions, dataOptions);

                // Добавляем навигацию без прописывания параметров в data-swiper
                if (dataOptions["navigation"] === undefined) {
                    if (element.querySelector(".swiper-button-next")) {
                        let navOptions = {
                            navigation: {
                                nextEl: element.querySelector(".swiper-button-next"),
                                prevEl: element.querySelector(".swiper-button-prev")
                            }
                        }
                        dataOptions = $.extend({}, dataOptions, navOptions);
                    } else if (element.closest(".swiper-outer") && element.closest(".swiper-outer").querySelector(".swiper-button-next")) {
                        let navOptions = {
                            navigation: {
                                nextEl: element.closest(".swiper-outer").querySelector(".swiper-button-next"),
                                prevEl: element.closest(".swiper-outer").querySelector(".swiper-button-prev")
                            }
                        }
                        dataOptions = $.extend({}, dataOptions, navOptions);
                    }
                }

                new Swiper(element, dataOptions);
            });
        }

        return ThemeSwiper;

    })();

    waTheme.init.site.Swiper = ThemeSwiper;

    new window.waTheme.init.site.Swiper();

})(window.waTheme);

// let initSwiper = () => {
//
//     let sliders = document.querySelectorAll("[data-swiper]");
//
//     let defaultOptions = {
//         // breakpointsInverse: true,
//         // observer: true
//     };
//
//     sliders.forEach(element => {
//
//         let data = element.getAttribute("data-swiper");
//         let dataOptions = data ? JSON.parse(data) : {};
//
//         dataOptions = $.extend({}, defaultOptions, dataOptions);
//
//         if (element.closest(".swiper-outer") && element.closest(".swiper-outer").querySelector(".swiper-button-next")) {
//             let navOptions = {
//                 navigation: {
//                     nextEl: element.closest(".swiper-outer").querySelector(".swiper-button-next"),
//                     prevEl: element.closest(".swiper-outer").querySelector(".swiper-button-prev")
//                 }
//             }
//             dataOptions = $.extend({}, dataOptions, navOptions);
//         }
//
//         new Swiper(element, dataOptions);
//     });
// };

$(document).ready(function () {
    // initSwiper();
});